import { DataSyncMetadataGroup, DataSyncResult } from '@/types/DataSyncServiceType'
import { BaseSearchOption } from '@/types/utilTypes'
import axios from 'axios'
import { ILoggingService } from './LoggingService'

export default class DataSyncService {
    private readonly _logging: ILoggingService
    private readonly baseUrl = '/data-sync'

    constructor(logging: ILoggingService) {
        this._logging = logging
    }

    public async getData(search: BaseSearchOption) : Promise<DataSyncResult> {
        const url = `${this.baseUrl}/search`

        try {
            return (await axios.post(url, search)).data
        } catch(error){
            this._logging.LogError(url, error)
            throw error
        }
    }

    public async getDataBySource(source: string): Promise<DataSyncMetadataGroup> {
        const url = `${this.baseUrl}/source/${source}`

         try {
            return (await axios.get(url)).data
        } catch(error){
            this._logging.LogError(url, error)
            throw error
        }
    }

    public async upsertDataSource(dataSource: DataSyncMetadataGroup): Promise<void> {
        const url = `${this.baseUrl}`
        try {
            await axios.post(url, dataSource)
        } catch(error){
            this._logging.LogError(url, error)
            throw error
        }
    }
}